export const SessionType = {
  Family: 'FAMILY',
  Individual: 'INDIVIDUAL'
}
